import state from "./state";
import actions from "./actions";
import mutations from "./mutations";

const getters = {
  getSchoolLeaveDetailList: (state) => state.items,
  getSchoolLeaveDetailListPagination: (state) => state.pagination,
  getSchoolLeaveDetailListPage: (state) => state.pagination.current_page,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
